<div class="searchBarOperator__cont" [id]="selector | uniqueId : type">
  <app-ds-button-snippet
    [defaultValue]="quantity"
    [minValue]="minValue"
    [maxValue]="maxValue()"
    (emitValue)="quantityEmmiter.emit($event)">
  </app-ds-button-snippet>
</div>